// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1O7HJ","title":"Header_title__20DmJ","side":"Header_side___MBmT"};